<script>
import RoomStore from '@/store/room';
export default {
  name: "RoomEmptyStory",
  computed: {
    sessionStarted(){
      return RoomStore?.isStarted;
    },

    hasStories() {
      return !!RoomStore?.stories?.length;
    },

    showNextAction() {
      return !!this.hasStories && !!RoomStore?.room?.started_at && !RoomStore?.activeStory;
    },
  }
}
</script>

<template>
  <div
      class="flex flex-col justify-center items-center w-full bg-white border border-gray-200 dark:bg-dark-modal dark:border-dark-border shadow rounded h-96 mb-4">

    <div class="clock"/>
    <div class="flex flex-col w-full justify-center items-center text-gray-600 dark:text-dark-text mt-4 text-xl">
      <span>Waiting for moderator</span>
      <span v-if="!sessionStarted">to start the session.</span>
      <span v-else-if="!!showNextAction">to select the story.</span>
      <span v-else-if="!hasStories">to add new stories.</span>
    </div>
  </div>
</template>

<style scoped>

.clock {
  margin-bottom: 10px;
  border-radius: 70px;
  @apply border-2 border-gray-400;
  display: block;
  width: 60px;
  height: 60px;
  position: relative
}

.clock:after {
  content: "";
  position: absolute;
  @apply bg-gray-400;
  top: 6px;
  left: 48%;
  height: 22px;
  width: 3px;
  -webkit-animation: hours 8s linear infinite;
  animation: hours 8s linear infinite;
  border-radius: 5px;
  -webkit-transform-origin: 50% 97%;
  transform-origin: 50% 97%;
}

@-webkit-keyframes hours {
  0% {-webkit-transform: rotate(0deg)}
  to {-webkit-transform: rotate(360deg)}
}

@keyframes hours {
  0% {transform: rotate(0)}
  to {transform: rotate(360deg)}
}

.clock:before {
  content: "";
  position: absolute;
  @apply bg-gray-400;
  -webkit-animation: minutes 48s linear infinite;
  animation: minutes 48s linear infinite;
  top: 11px;
  left: 48%;
  height: 17px;
  width: 3px;
  border-radius: 5px;
  -webkit-transform-origin: 50% 94%;
  transform-origin: 50% 94%;
}

@-webkit-keyframes minutes {
  0% {-webkit-transform: rotate(0deg)}
  to {-webkit-transform: rotate(360deg)}
}

@keyframes minutes {
  0% {transform: rotate(0)}
  to {transform: rotate(360deg)}
}
</style>
